module.exports = __webpack_public_path__ + "img/adver03.55568870.jpg";